import { Divider } from '@mui/material';
import { SubscriptionRevenue } from './SubscriptionRevenue';
import { OtpRevenue } from './OtpRevenue';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { OtpOfferRevenue } from './OtpOfferRevenue';

type PayoutRulesProps = {
  influencerId: number;
};

export const PayoutRules = (p: PayoutRulesProps) => {
  return (
    <div className="px-[30px] py-[40px] bg-white rounded-xl">
      <Typography variant="headline" size="medium" className="mb-2.5">
        Payout rules
      </Typography>
      <Typography
        variant="body"
        size="large"
        className={sprinkles({ color: 'N-60' })}
      >
        Any changes made to these settings will be applied from this date
        onward; these changes do not apply to past transactions.
      </Typography>
      <div className="mt-[30px]">
        <SubscriptionRevenue influencerId={p.influencerId} />
      </div>
      <Divider
        variant="fullWidth"
        className="my-[30px]"
        sx={{ borderColor: 'rgba(33, 40, 49, 0.12)' }}
      />
      <div>
        <OtpRevenue influencerId={p.influencerId} />
      </div>
      <Divider
        variant="fullWidth"
        className="my-[30px]"
        sx={{ borderColor: 'rgba(33, 40, 49, 0.12)' }}
      />
      <div>
        <OtpOfferRevenue influencerId={p.influencerId} />
      </div>
    </div>
  );
};
